<template>
  <div>
    <ul>
      <li v-for="loc in locations" :key="loc.id">
        <router-link :to="{ name: 'volunteers', params: { id: loc.id } }">{{
          loc.name
        }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "MngVolunteers",
  data: () => ({
    locations: []
  }),
  methods: {
    onLoad() {
      this.axios
        .get(process.env.VUE_APP_API_URL + "locations")
        .then(res => (this.locations = res.data))
        .catch(err => console.log(err));
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>
